module.exports = __webpack_public_path__ + "static/media/ico-sign-in.f004e825.svg";